





































































































































import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import {
  IInvoiceCreditRefundProvider,
  IInvoiceCreditRefundProviderMethods
} from "@/models/providers/invoiceCreditRefund";
import { IPayment } from "@/models/payment";

@Component
export default class InvoiceRefundPaymentsTable extends Vue {
  @Inject({ from: "invoiceCreditRefundProvider" })
  public readonly $invoiceCreditRefundProviderData!: () => IInvoiceCreditRefundProvider;

  @Inject({ from: "invoiceCreditRefundProviderMethods" })
  public readonly $invoiceCreditRefundProviderMethods!: IInvoiceCreditRefundProviderMethods;

  public allChecked = true;
  public checkedPayments: IPayment[] = [];
  public paymentAmounts: { [key: string]: number } = {};

  // Computed
  public get providerData() {
    return this.$invoiceCreditRefundProviderData();
  }

  public get availablePayments() {
    return this.allPayments.filter(i => i.isPayable);
  }

  public get allPayments() {
    return (this.providerData.invoice.payments || []).map(payment => ({
      ...payment,
      isPayable: this.isPayable(payment)
    }));
  }

  @Watch("checkedPayments", { deep: true })
  public onCheckedPaymentsChanged() {
    this.emitData();

    this.allChecked =
      this.checkedPayments.length === this.availablePayments.length;
  }

  @Watch("paymentAmounts", { deep: true })
  public onPaymentAmountsChanged() {
    this.emitData();
  }

  @Watch("providerData.isLoading", { immediate: true })
  public setPaymentAmounts() {
    this.availablePayments.forEach(payment => {
      if (!payment.isPayable) {
        return;
      }
      this.checkedPayments.push(payment);
      this.$set(
        this.paymentAmounts,
        payment.id,
        payment.amount_for_refund_converted
      );
    });
  }

  public isPayable(payment) {
    return (
      payment.amount_for_refund_converted &&
      !payment?.gateway?.gateway_provider?.external_store
    );
  }

  public emitData() {
    const paymentAmounts: { [key: string]: number } = {};
    this.availablePayments.forEach(payment => {
      if (
        !this.checkedPayments.includes(payment) ||
        !this.paymentAmounts[payment.id]
      ) {
        return;
      }
      paymentAmounts[payment.id] = this.paymentAmounts[payment.id];
    });

    this.$emit("amounts-changed", paymentAmounts);
  }

  public toggleAll(value) {
    this.checkedPayments = [];
    if (!value) {
      return;
    }
    this.availablePayments.forEach(payment => {
      if (!payment.amount_for_refund_converted) {
        return;
      }
      this.checkedPayments.push(payment);
      this.$set(
        this.paymentAmounts,
        payment.id,
        payment.amount_for_refund_converted
      );
    });
  }
}
